import styled from "styled-components";

export const Container = styled.div`
  input {
    --tw-ring-offset-color: hsl(var(--background));
    font-size: 0.875rem;
    line-height: 1.25rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    background-color: hsl(var(--background));
    --tw-border-opacity: 1;
    border-color: rgb(107 114 128 / var(--tw-border-opacity));
    border-width: 1px;
    border-radius: calc(var(--radius) - 2px);
    width: 100%;
    height: 2.5rem;
    display: flex;
    margin-top: '5px';
  }


`;